import $ from 'jQuery';

const $window = $(window);

function closeModal(targetModal) {
    if (targetModal == undefined) return;
    if ($(targetModal).is(':visible')) {
        $(targetModal).closest('.modal__backdrop').removeClass('visible');
        $(targetModal).fadeOut(400, () => {
            $window.trigger('html:scroll');
        });
    }
}

function openModal(targetModal) {
    if (targetModal == undefined) return;
    if ($(targetModal).is(':hidden')) {
        $(targetModal).closest('.modal__backdrop').addClass('visible');
        $(targetModal).fadeIn(400);
        $window.trigger('html:noscroll');
    }
}

$(function () {
    $(document).on('click', '.modal-trigger', function () {
        let targetModal = $(this).data('target');
        openModal(targetModal);
    });

    $('.modal').on('click', function (event) {
        event.stopImmediatePropagation();
    });
    $('.modal__backdrop').on('click', function () {
        let targetModal = $(this).find('.modal');
        closeModal(targetModal);
    });
    $('.modal__close, .modal-close').on('click', function () {
        let targetModal = $(this).closest('.modal');
        closeModal(targetModal);
    });
});
